import React, { useState } from 'react';
import { signInWithEmailAndPassword, sendPasswordResetEmail } from 'firebase/auth';
import { auth } from '../firebase';
import { useNavigate } from 'react-router-dom';

function Login() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [resetSent, setResetSent] = useState(false);
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    setError('');
    try {
      await signInWithEmailAndPassword(auth, email, password);
      navigate('/dashboard');
    } catch (err) {
      setError('Invalid email or password');
    }
  };

  const handleResetPassword = async () => {
    if (!email) {
      setError('Please enter your email to reset password');
      return;
    }
    try {
      await sendPasswordResetEmail(auth, email);
      setResetSent(true);
      setError('');
    } catch (err) {
      setError('Failed to send reset email. Please check your email address.');
    }
  };

  return (
    <div className="min-h-screen bg-[#e9f2f9] flex flex-col items-center justify-center p-4">
      {/* Logo and Title */}
      <div className="text-center mb-6">
        <img
          src="https://i.postimg.cc/sx4XWC3B/ALL-ZONES-Final-Logo-22-4-25.png"
          alt="All Zones Logo"
          className="mx-auto w-28 h-28"
        />
        <h1 className="text-3xl text-blue-800 font-semibold" style={{ fontFamily: 'Cinzel, serif' }}>
          ALL ZONES WATER TREATMENT
        </h1>
        <p className="text-gray-700 text-sm">Welcome to the Inventory Portal</p>
      </div>

      {/* Login Card */}
      <form onSubmit={handleLogin} className="bg-white p-6 rounded shadow-md w-full max-w-md">
        <h2 className="text-center text-lg font-semibold mb-5">Login to Inventory App</h2>
        {error && <p className="text-red-500 text-sm text-center mb-2">{error}</p>}
        {resetSent && <p className="text-green-600 text-sm text-center mb-2">Reset email sent. Check your inbox.</p>}

        <input
          type="email"
          placeholder="Email"
          className="border border-gray-300 p-3 w-full mb-3 rounded"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
        />
        <input
          type="password"
          placeholder="Password"
          className="border border-gray-300 p-3 w-full mb-3 rounded"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          required
        />

        <div className="flex justify-between items-center text-sm mb-3">
          <button
            type="button"
            onClick={handleResetPassword}
            className="text-blue-600 hover:underline"
          >
            Forgot Password?
          </button>
        </div>

        <button
          type="submit"
          className="bg-blue-600 text-white py-2 w-full rounded hover:bg-blue-700 transition"
        >
          Login
        </button>
      </form>

      {/* Footer */}
      <footer className="mt-6 text-center text-xs text-gray-600">
        © 2025 ALL ZONES WATER TREATMENT AND PURIFICATION EQUIPMENT TRADING - All Rights Reserved.
      </footer>
    </div>
  );
}

export default Login;
